import '@/core/bootstrap';
import '@/core/config';
import '@/components';
import '@/directives';
import '@/services';
import '@/modules';

import 'bootstrap';

/*------------------------------------------------------
 * Registra o modulo app
 *------------------------------------------------------
 * Armazenamos a instancia da plicação no container
 * window para podermos executar testes em tempo de
 * execução.
 */
window.app = angular.module('app', [
  'bootstrap',
  'app.components',
  'app.directives',
  'app.services',
  'app.modules'
]);

/*------------------------------------------------------
 * Inicializa a aplicação
 *------------------------------------------------------
 * Utilizar o bootstrap para inicializar a applicação
 * nos da mais controle sobre o gerenciamento e carregamento
 * de modulos.
 */
angular.bootstrap(document, ['app'], {
    strictDi: true
});



// WEBPACK FOOTER //
// ./src/main.js